import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { AdminLogin } from './AdminLogin';

interface ProtectedRouteProps {
  children?: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Memuat...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    // Show login page for admin routes
    if (location.pathname.startsWith('/admin')) {
      return <AdminLogin />;
    }
    // Redirect to login for other protected routes
    return <AdminLogin />;
  }

  // If children are provided, render them (legacy support)
  if (children) {
    return <>{children}</>;
  }

  // Otherwise, render the outlet for nested routes
  return <Outlet />;
};